import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	chatToolsConnectTableWorkspaceHeadNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-workspace-head-non-final',
		defaultMessage: 'Workspace or tenant',
		description: 'Transition home chat tools step table workspace head',
	},
	chatToolsConnectTableProductHeadNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-product-head-non-final',
		defaultMessage: 'Product',
		description: 'Transition home chat tools step table product head',
	},
	chatToolsConnectTableStatusHeadNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-status-head-non-final',
		defaultMessage: 'Status',
		description: 'Transition home chat tools step table status head',
	},
	chatToolsConnectTableStatusHeadTooltipNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-status-head-tooltip-non-final',
		defaultMessage: 'Make sure you’re a member of the Slack workspace or Microsoft tenant.',
		description: 'Transition home chat tools step table status head tooltip',
	},
});
